export default {
  //Việt Nam / Tiếng Việt VN vi
LandingPage: {
  intro_sub:
    'Sống xanh cùng Samsung, mang lại cơ hội tái sinh cho bao bì TV, chung tay bảo vệ môi trường.',
  title: 'Samsung Upcycle-Bao bì',
  sequence1_1: 'Cùng chúng tôi giảm thiểu rác thải',
  sequence1_2:
    'Sáng tạo với bao bì TV để biến chúng thành những vật dụng hữu ích cho một hành tinh xanh. Cuộn xuống để bắt đầu.',
  sequence2_1: 'Giới thiệu Samsung Upcycle-Bao bì',
  sequence2_2:
    'Bao bì TV được thiết kế đặc biệt để cùng bạn đóng góp vào hành trình bảo vệ môi trường. Dễ dàng biến những bao bì TV thành những vật dụng hữu ích cho ngôi nhà của bạn.',
  sequence3_1: 'Làm theo đường kẻ được in trên vỏ hộp',
  sequence3_2:
    'Cắt theo chỉ dẫn và lắp ráp để sáng tạo nên những vật dụng thú vị.',
  sequence4_1: 'Chọn vật dụng bạn muốn làm',
  sequence4_2:
    'Kéo xuống và chọn mẫu sản phẩm TV bạn có bao bì. Sau đó tìm kiếm thiết kế bạn mong muốn. Giờ đây, hãy bắt đầu hành trình sáng tạo của riêng bạn với bao bì TV Samsung.',
  selectBox: 'Chọn mẫu TV',
  moreActivity:
    "Thông tin chi tiết về giải pháp bền vững từ Samsung",
  OLED: 'OLED',
  QLED8K: 'QLED', //update
  UHD: 'Crstal UHD', //update
  theFrame: 'The Frame', //update
  theSerif: 'The Serif', //update
  theSero: 'The Sero', //update
  theTerrace: 'The Terrace', //update
  thePremiere: 'The Premiere', //update
  Monitors: 'Màn hình', //update
  OdysseyArk:"Odyssey Ark",
  QSoundbar: 'Loa Thanh Q-series', //update
  Soundbar: 'Loa Thanh', //update
  SoundbarSet01:'Bộ loa thanh 1',
  SoundbarSet02:'Bộ loa thanh 2',
  TheTerraceSoundbar:'The Terrace Soundbar',
  Soundtower:'Sound Tower',
  BespokeJet: 'BESPOKE Jet\n (Jet)',
  BespokeJetStation:'BESPOKE Jet\n (Clean Station™)',
  BespokeJetNCleanStation : 'BESPOKE Jet&\nClean Station™',
  BespokeJetNCleanStation2 : 'BESPOKE Jet&Clean Station™',
  BespokeCube53:'BESPOKE Cube™ AIR\n(53㎡)',
  BespokeCube70:'BESPOKE Cube™ AIR\n(70㎡)',
  BespokeCube106:'BESPOKE Cube™ AIR\n(106㎡)',
  BespokeCube123:'BESPOKE Cube™ AIR\n(123㎡)',
  Qooker:'Qooker',
  BespokeSlim:'BESPOKE Slim',
  TheFreeStyle:"The Freestyle",
  BespokeSlimCleanStation:"BESPOKE Slim&Jet\n(Clean Station™)",
  JetCleanStation:"Jet&\nClean Station™",
  JetCleanStation2:"Jet&Clean Station™",
  BlueSky:"BlueSky \n5500",
  BlueSky3000:"BlueSky \n3000",
  BlueSky3100:"BlueSky \n3100",
  BlueSky5000:"BlueSky \n5000",
  BespokeJetbot:"BESPOKE\n Jet Bot",
  BespokeJetbot2:"BESPOKE Jet Bot",
  BespokeJetbotPlus:"BESPOKE\n Jet Bot+",
  BespokeJetbotPlus2:"BESPOKE Jet Bot+",
  BespokeJetbotAI:"BESPOKE\n Jet Bot AI",
  BespokeJetbotAI2:"BESPOKE Jet Bot AI",
  Canister01:"Canister \n01",
  Canister02:"Canister \n02",
  Jupiter:"Vacuum \nCleaner",
  ref_cube:"BESPOKE Cube",
  WaterPurifier:"Water Purifier",
  LATIN:"LATIN",
  LATIN10:"LATIN10",
  MIRROR:"MIRROR",
  MW5100J:"MW5100J",
  STENA:"STENA",
  // moreActivityLink:
  //   'https://www.samsung.com/us/sustainability/overview/',
  moreActivityLink:'https://www.samsung.com/vn/aboutsamsung/sustainability/strategy/',
  footer: `
  bản quyền © 2019-2021 SAMSUNG Bảo lưu mọi quyền.`,
},
ProductPage: {
  selectDesign: 'Chọn mẫu thiết kế',
  selectDesignDezeen: 'Samsung X Dezeen', //update
  selectDesignSoccer: 'Samsung X Football', 
  tvConsole: 'Kệ TV',
  StorageBox: 'Hộp đựng đồ',
  MagazineRack: 'Kệ để Tạp chí',
  CatHouse: 'Nhà cho mèo',
  CatTunnel: 'Đường hầm cho mèo',
  BookShelf: 'Giá sách',
  DeskShelf: 'Kệ để bàn',
  BlackRhino: 'Động vật nguy cấp Tê giác đen', //update
  PolarBear: 'Động vật nguy cấp Gấu bắc cực', //update
  SeaTurtle: 'Động vật nguy cấp Rùa biển', //update
  TheRider: 'Ngựa bập bênh', //update
  Kibe: 'Kệ ba tầng', //update
  Tessellate: 'Kệ đa năng', //update
  Twist: 'Hộp xoắn', //update
  AlexCouchArmTable: 'Bàn gắn trên ghế sofa', //update
  BlastOffClubHouse: 'Nhà mini cho búp bê', //update
  KinokoTable: 'Bàn Kinoko', //update
  Magnuss: 'Hộp để đèn', //update
  GIO: 'Chân đế để đèn', //update
  PostCardPlanter: 'Kẹp bưu thiếp', //update
  SneakerRack: 'Kệ để giày', //update
  TheSoban: 'Bàn trà nhỏ', //update
  ToolBox: 'Hộp đựng dụng cụ', //update
  DeskStationary: 'Hộp văn phòng phẩm',
  CoinBank: 'Hộp đựng tiền',
  MobileScanner:'Kệ để điện thoại thông minh',
  TabletScanner:'Kệ để máy tính bảng',
  PetStairs:'Cầu thang cho thú cưng',
  PetFurniture:'Đồ chơi cho thú cưng',
  ShoeRackA:'Kệ giày_A',
  ShoeRackB:'Kệ giày_B',
  WineRackDog:'Giá rượu hình con chó',
  WineRack:'Giá rượu',
  mins: 'phút',
  all:'Tất cả',
  in: 'trong',
  inOnly: 'chỉ trong',
  allBoxSize: 'Tất cả kích thước',
  soccergoalpost:'Mini Soccer Goal Post',
   soccerboard:'Table Soccer Board',
   sixpackcarrier:'Six Pack Carrier',
   trophytable:'Trophy Cup Table',
   megaphone:'Cheer Megaphone',
   FreestyleBear:'Small \n Animals \n Polar Bear',
   FreestyleRay:'Small \n Animals \n Ray',
   FreestyleRhino:'Small \n Animals \n Black Rhino',
   FreestyleSeahorse:'Small \n Animals \n See Horse',
   FreestyleWhale:'Small \n Animals \n Whale',
   Mickey:'Mickey Mouse',
   Pluto:'Pluto',
   Diseny:'Samsung X Disney'
},
DetailGuidePage: {
  1:'1',
  2:'2',
  3:'3',
  instructions: 'hướng dẫn',
  prepare: 'Chuẩn bị hộp',
  LetsDesign: "Thiết kế nào",
  drawParts: 'Vẽ các bộ phận trên hộp',
  note1: 'Lưu ý rằng vị trí đồ họa có thể khác nhau tùy theo quốc gia và kích thước',
  note2: 'Phác thảo toàn bộ bản vẽ trước để nó vừa với hộp',
  numberSpace: 'số = khoảng trắng giữa các dấu chấm',
  diagonal: 'đường chéo',
  LEFT: 'TRÁI',
  RIGHT: 'PHẢI',
  TOP: 'PHẦN TRÊN',
  TOP1: 'PHẦN TRÊN 1',
  TOP2: 'PHẦN TRÊN 2',
  BACK: 'PHẦN SAU',
  MIDDLE: 'PHẦN GIỮA',
  MIDDLE2: 'PHẦN GIỮA 2',
  BOTTOM: 'PHẦN ĐÁY',
  FRONT: 'PHẦN TRƯỚC',
  SIDE: 'MẶT BÊN',
  secondSIDE: 'MẶT BÊN THỨ HAI',
  secondSIDE1: 'MẶT BÊN THỨ HAI 1',
  secondSIDE2: 'MẶT BÊN THỨ HAI 2',
  LEG: 'CHÂN ĐẾ', //update
  JOINT: 'ĐẦU NỐI', //update
  FACE: 'MẶT', //update
  DRAWERBOTTOM: 'NGĂN KÉO DƯỚI', //update
  DRAWERSIDE: 'NGĂN KÉO BÊN', //update
  NOSE: 'MŨI', //update
  HANDLE: 'TAY CẦM', //update
  BOTTOMSIDE: 'MẶT ĐÁY', //update
  TOPSIDE: 'MẶT TRÊN', //update
  WING: 'CÁNH', //update
  cutAndAssemble: "Cắt & Lắp ráp",
  beCareful: 'Cẩn thận để không bị thương khi sử dụng máy cắt',
  cutOutParts: 'Cắt rời các bộ phận',
  assemble: 'Lắp ráp',
  Assemblyguide: 'Hướng dẫn lắp ráp', //update
  fold: 'Ví dụ gấp',
  foldGuide: 'Sử dụng cạnh khi gấp bìa các tông',
  foldGuideDezeen:
    'Nhấn đường chấm trên bìa các tông bằng dụng cụ tạo nếp gấp một vài lần để giúp bìa tông dễ gấp hơn', //update
  glue: 'Bôi keo hoặc băng dính đều trên bề mặt', //update
  cable: 'Sử dụng dây cáp hoặc dây thừng để buộc lại', //update
  done: 'Hoàn thành',
  goBack: 'Quay lại menu chính',
},
CautionPage: {
  CAUTION: 'LƯU Ý',
  needItem: 'Bạn sẽ cần đọc những điều này',
  children: 'Trẻ em nên thực hiện cùng người lớn',
  mat:
    'Vui lòng đặt một tấm phủ trên mặt đất để tránh trầy xước trong khi thực hiện',
  doNotPutHeavyThing:
    'Không bước hoặc ngồi lên những vật dụng này và không đặt vật nặng lên chúng',
  doNotThrow:
    'Không ném hoặc đá những vật dụng này về phía bất cứ thứ gì kể cả người và động vật',
  stayAwayFlame: 'Để xa nguồn cháy',
  stayAwayWater: 'Không để gần nước hoặc nơi có độ ẩm',
  mayDamaged: '* Hộp TV có thể bị hỏng trong quá trình vận chuyển',
  companyDoestResponsible:
    '* Công ty không có bất kỳ trách nhiệm nào đối với sự cố hoặc thương tích trong quá trình thực hiện',
  cannotBeReturned:
    '* Sản phẩm có hộp bị hỏng không thể trả lại vì các vấn đề không liên quan đến chất lượng',
  understand: 'Ok, tôi đã hiểu',
},
PrivacyPolicy: {
  title: 'Chính sách bảo mật',
},
GoingGreen: {
  visual: {
    title: 'Sống Xanh',
    text1:
      'Chúng tôi đã sử dụng ít giấy và mực hơn cho phần lớn bao bì TV so với trước đây để tiến xa hơn trong cam kết về tính bền vững',
    text2:'',
    text2_special:
      '(* Điều trên không áp dụng cho một số mẫu sản phẩm bao gồm TV Lifestyle)',
    text3: 'Chọn các nút bên dưới để khám phá thêm',
  },
  greenIn: {
    title: 'Sống xanh với bao bì TV',
    subtitle1: 'Tìm kiếm thông tin sản phẩm',
    subtitle2: 'Nâng cấp Bao bì sinh thái',
    desc: 'Tìm kiếm tên mẫu sản phẩm để có thêm thông tin',
    descM: '* Chụp ảnh số trên mẫu sản phẩm TV',
    guide: 'tên mẫu sản phẩm',
    button: 'Chụp hình',
    button2: 'Đi đến trang làm vật dụng',
    product_info: 'Thông tin sản phẩm',
  },
  search: {
    guide: 'Tìm kiếm..',
    noResult: 'Không có kết quả',
    more: 'NHIỀU HƠN',
    search: 'Tìm kiếm',
    retake: 'Chọn lại',
    result: 'Kết quả',
  },
  photo: {
    guide1: 'Để tên mẫu sản phẩm TV lên hộp',
    guide2: '(ví dụ: Q800A, UT7000, RU7100, v.v.)',
  },
},
searchCountrySelect: 'Chọn một quốc gia để bắt đầu tìm kiếm'
};
